import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';

/** 🔔 Notification model – съобразен с твоя бекенд */
export interface Notification {
	id: number;
	description: string;
	createdAt: string;
	deadline?: string;
	read: boolean;
	status: 'ACTIVE' | 'READ' | 'DONE';
	lawsuiteId : number;
}

@Injectable({
	providedIn: 'root'
})
export class NotificationService {

	constructor(
		private http: HttpService
	) { }

	private readonly baseUrl = environment.serviceBaseUrl + '/api/notifications';

	/** 🔹 Нотификации за header (последни 3 дни) */
	loadHeader(): Observable<Notification[]> {
		return this.http.get<Notification[]>(
			this.baseUrl + '/header'
		);
	}

	/** 🔹 Брой непрочетени */
	unreadCount(): Observable<number> {
		return this.http.get<number>(
			this.baseUrl + '/header/unread-count'
		);
	}

	/** 🔹 Маркиране като прочетена */
	markRead(id: number): Observable<void> {
		return this.http.post<void>(
			this.baseUrl + `/${id}/read`,
			{}
		);
	}

	/** 🔹 (по избор) mark all as read */
	markAllRead(): Observable<void> {
		return this.http.post<void>(
			this.baseUrl + `/read-all`,
			{}
		);
	}
}
